
export enum TriggerPurchaseBlockNotificationsSaleType {
  Auction= 'Auction',
  DirectSale= 'DirectSale',

}